// 获取技术人员select
const GETDEVOPSSELECT = 'getDevopsSelect';
const GETDEVOPSSYSTEM = 'getDevopsSystem';
const GETDEVOPSUSERLIST = 'getDevopsUserList';

const GETDEVOPSSTATUSLIST = 'getDevopsStatusList';

const GETDEVOPSNENULIST = 'getDevopsMenuList';

const GETDEVOPSWORKORDERCONFIG = 'getDevopsWorkOrderConfig';

export {
    GETDEVOPSSELECT,
    GETDEVOPSSYSTEM,
    GETDEVOPSUSERLIST,
    GETDEVOPSSTATUSLIST,
    GETDEVOPSNENULIST,
    GETDEVOPSWORKORDERCONFIG,
}
